import { footer } from './fr/footer';
import { navigation } from './fr/navigation';
import { easterCamp, christmasCamp, summerCamp, summerCampConfirmation } from './fr/camps';
import { prices } from './fr/prices';
import { montessori } from './fr/montessori';
import { openHouse } from './fr/openHouse';
import { extracurriculars } from './fr/extracurriculars';
import { feedback } from "./fr/feedback";
import { courses } from "./fr/courses";
import { schoolCalendar } from './fr/schoolCalendar';
import { birthdays } from './fr/birthdays';
import { services } from './fr/services';
import { admissions } from './fr/admissions';
import { enrollmentForm } from './fr/enrollmentForm';
import { enrollmentConfirmation } from './fr/enrollmentConfirmation';
import { hero } from './fr/hero';
import { trustBadges } from './fr/trustBadges';
import { valueProposition } from './fr/valueProposition';
import { testimonials } from './fr/testimonials';
import { ctaSection } from './fr/ctaSection';
import { gallery } from './fr/gallery';
import { activities } from './fr/activities';
import { principles } from './fr/principles';
import { howWeTeach } from './fr/howWeTeach';
import { trilingualModel } from './fr/trilingualModel';
import { neasc } from './fr/neasc';
import { visitBanner } from './fr/visitBanner';
import { renewalForm } from './fr/renewalForm';
import { renewalConfirmation } from './fr/renewalConfirmation';
import { openHouseRegistration } from './fr/openHouseRegistration';

export const fr = {
  navigation,
  footer,
  hero,
  trustBadges,
  valueProposition,
  howWeTeach,
  trilingualModel,
  neasc,
  gallery,
  activities,
  principles,
  testimonials,
  ctaSection,
  easterCamp,
  christmasCamp,
  summerCamp,
  summerCampConfirmation,
  prices,
  montessori,
  openHouse,
  openHouseRegistration,
  extracurriculars,
  feedback,
  courses,
  schoolCalendar,
  birthdays,
  services,
  admissions,
  enrollmentForm,
  enrollmentConfirmation,
  renewalForm,
  renewalConfirmation,
  visitBanner,
  title: "Gándara International School",
  description: "Gándara International School, éducation Montessori à Vigo",
  trilingual: {
    title: "Éducation Trilingue",
    metaDescription: "Notre approche trilingue à Gándara International School",
    bookVisit: "Réserver une Visite",
    intro: {
      p1: "À Gándara International School, nous croyons en l'offre d'une éducation véritablement mondiale qui prépare les élèves au monde connecté dont ils hériteront.",
      p2: "Notre programme trilingue immerge les élèves en espagnol, anglais et Galician, créant des opportunités naturelles pour l'acquisition de langues et la compréhension culturelle."
    },
    sections: {
      immersion: {
        title: "Immersion Naturelle en Langues",
        p1: "Plutôt que d'enseigner les langues comme des matières isolées, notre approche intègre les langues tout au long de la journée scolaire. Les enfants expérimentent différentes langues en contexte, établissant des connexions et développant une fluidité naturelle.",
        p2: "Chaque langue a des temps et des espaces dédiés, avec des enseignants natifs ou hautement compétents créant un environnement linguistique authentique."
      },
      languages: {
        title: "Trois Langues, Une Communauté",
        p1: "L'espagnol sert de langue principale d'instruction, reliant les élèves à notre communauté locale et à la culture espagnole.",
        p2: "L'anglais et le Galician sont intégrés dans tout le programme, avec des matières et des activités spécifiques menées dans chaque langue pour assurer une exposition et une pratique équilibrées."
      },
      benefits: {
        title: "L'Avantage Multilingue",
        intro: "La recherche montre constamment que les enfants qui apprennent plusieurs langues dès leur plus jeune âge développent des avantages cognitifs significatifs:",
        list: [
          "Amélioration des compétences en résolution de problèmes et en pensée créative",
          "Meilleure mémoire et traitement de l'information",
          "Plus grande conscience culturelle et empathie",
          "Amélioration des performances académiques dans toutes les matières",
          "Amélioration des opportunités éducatives et professionnelles à l'avenir"
        ],
        conclusion: "Ces avantages s'étendent bien au-delà des compétences linguistiques, soutenant le développement holistique et préparant les élèves au succès dans une société de plus en plus mondiale."
      },
      methodology: {
        title: "Notre Approche",
        content: "Notre méthodologie trilingue est conçue en tenant compte des capacités naturelles d'acquisition du langage des enfants. Les jeunes enfants ont une capacité innée à absorber les langues sans la confusion souvent expérimentée par les adultes. Grâce à des expériences immersives, des activités engageantes et une exposition constante, les élèves développent des compétences de communication confiantes dans les trois langues."
      },
      environment: {
        title: "Un Environnement de Soutien",
        p1: "Nous créons une atmosphère positive et encourageante où les élèves se sentent en sécurité pour pratiquer de nouvelles langues sans crainte de faire des erreurs. L'apprentissage est actif, contextuel et significatif.",
        p2: "Nos petites classes garantissent que chaque enfant reçoit une attention individualisée et de nombreuses opportunités pour pratiquer l'expression orale et l'écoute dans chaque langue."
      }
    }
  },
  about: {
    title: "À Propos",
    subtitle: "Rencontrez notre équipe d'accompagnateurs dédiés à l'éducation et à la croissance de chaque enfant",
    bookVisit: "Réservez une visite",
    story: {
      title: "Notre Histoire",
      content: "Gándara est née en 2013 du rêve de deux familles cherchant une éducation différente pour leurs enfants : un espace où le respect, la nature et la liberté seraient les fondements de l'apprentissage. Ce qui a commencé comme une petite école dans une propriété à Gondomar est devenu une école internationale accréditée NEASC, avec une équipe d'accompagnateurs passionnés et une communauté de familles qui partagent la même vision."
    },
    mission: {
      title: "Notre Mission",
      content: "Accompagner chaque enfant dans son développement intégral, en respectant ses rythmes et processus naturels, dans un cadre naturel où l'apprentissage actif, la vie multilingue et la curiosité sont le moteur de chaque journée."
    },
    values: {
      title: "Nos Valeurs",
      items: [
        { title: "Respect", description: "Des rythmes, des émotions et des processus uniques de chaque enfant." },
        { title: "Autonomie", description: "Nous encourageons l'indépendance et la confiance en ses propres capacités." },
        { title: "Communauté", description: "Familles, accompagnateurs et enfants grandissent ensemble dans un projet partagé." },
        { title: "Nature", description: "Nos plus de 5 000 m² de propriété sont une salle de classe vivante pour apprendre et explorer." },
        { title: "Réinvestissement", description: "Gándara ne distribue aucun bénéfice : chaque euro est réinvesti dans l'école pour offrir la meilleure éducation possible." }
      ]
    },
    video: {
      title: "Découvrez notre école"
    },
    teamTitle: "Notre Équipe",
    photoComingSoon: "Photo bientôt",
    back: "Retour",
    team: [
      {
        name: "Patricia Méndez",
        role: "Codirectrice",
        description: "J'ai fondé Barkibu avec Pablo, le projet qui nous permet de soutenir Gándara et où nous prenons soin des animaux et de leurs familles. Nous sommes tombés amoureux de Gándara parce que nos filles grandissent ici et nous croyons que c'est la meilleure éducation possible : c'est pourquoi nous la soutenons et accompagnons les familles au quotidien."
      },
      {
        name: "Pablo Pazos",
        role: "Codirecteur",
        description: "Patricia et moi sommes les fondateurs de Barkibu, le projet qui nous permet de soutenir Gándara et où nous prenons soin des animaux et de leurs familles. Nous sommes tombés amoureux de Gándara en famille : nos filles étudient ici et nous croyons que c'est la meilleure éducation possible. C'est pourquoi nous la soutenons et la gérons pour qu'elle dure."
      },
      {
        name: "Iago Ferraz",
        role: "Fondateur, directeur pédagogique et accompagnant",
        description: "Pendant quinze ans, j'ai rêvé de créer une école différente : un lieu de vie fondé sur le respect et l'amour des enfants, en pleine nature. Aujourd'hui, ce rêve s'appelle Gándara, où j'apprends et je profite chaque jour avec les meilleurs maîtres : les enfants eux-mêmes. En faire partie me rend profondément reconnaissant."
      },
      {
        name: "Verónica Álvarez",
        role: "Sous-directrice",
        description: "Gándara est bien plus qu'un travail pour moi : c'est ma deuxième maison. Je suis heureuse de faire partie de cette petite grande famille et d'apprendre chaque jour des valeurs qu'on y respire : solidarité, liberté, intégrité et créativité."
      },
      {
        name: "Alba Couse",
        role: "Accompagnatrice de Maternelle",
        description: "Je suis institutrice de Maternelle, spécialisée en Audition et Langage, et je suis actuellement le master Montessori 0-6 de l'International Montessori Institute. J'ai connu Gándara lors de mon stage universitaire et je suis restée : cette année, j'accompagne la Maternelle, avec une attention particulière à la haute sensibilité et au soin."
      },
      {
        name: "Carmen Aguilar",
        role: "Accompagnatrice du Cycle 1",
        description: "Je suis institutrice de Primaire, spécialisée en langue anglaise. Mon expérience d'enseignante et de tutrice m'a permis d'accompagner des enfants aux rythmes, intérêts et besoins différents. Je continue à me former aux méthodologies actives et, en particulier, à la méthode Montessori. J'aborde cette nouvelle étape avec beaucoup d'enthousiasme et l'engagement d'accompagner chaque enfant avec sensibilité, respect et affection."
      },
      {
        name: "David Torres",
        role: "Accompagnant du Cycle 2 et responsable des Sciences",
        description: "Je suis océanographe et médiateur scientifique : depuis plus de dix ans, je rapproche la science de tous les publics, avec une formation en sciences Montessori, robotique éducative et gamification. J'aime que l'émerveillement devant la nature soit la porte de l'apprentissage, de la mer au potager."
      },
      {
        name: "Patricia Iglesias",
        role: "Accompagnatrice de Maternelle et anglais au Cycle 1",
        description: "Philologue de formation et éducatrice de vocation : je suis venue à l'éducation par amour des langues et je suis restée pour les enfants. J'enseigne depuis des années l'anglais aux plus petits par le jeu, avec une formation en pédagogies actives, Montessori et éducation dans la nature, et une approche où le lien émotionnel passe toujours en premier."
      },
      {
        name: "Paula Alonso",
        role: "Cantine et accompagnatrice de Maternelle",
        description: "Je suis institutrice de Maternelle et j'ai passé toute ma vie professionnelle entre l'éducation respectueuse et la nature : j'ai coordonné pendant des années l'espace 3-6 d'un projet d'éducation libre et dirigé un centre de loisirs pour enfants. À Gándara, j'accompagne la cantine et la Maternelle, où la table aussi est une école : manger calmement, discuter et prendre soin les uns des autres."
      },
      {
        name: "Sandra Amigo",
        role: "Accompagnatrice du Cycle 2 et spécialiste d'anglais",
        description: "Je suis enseignante spécialisée en langues étrangères, trilingue anglais-espagnol-catalan et Forest School Teacher. J'ai coordonné l'anglais dans des écoles de plus de 250 élèves et des projets éducatifs à l'université, toujours avec des méthodologies actives et Montessori. Mon moteur : construire un monde meilleur grâce à une éducation qui cultive l'empathie et le respect de tout ce qui nous entoure."
      },
      {
        name: "Yoli Paz",
        role: "Nettoyage et soin des espaces",
        description: "Je veille à ce que les espaces de Gándara soient propres et accueillants chaque jour. Un environnement soigné, ça éduque aussi."
      }
    ]
  }
};
